import { useContext } from "react";

import { AmwellProviderContext } from "/component/provider/AmwellProvider/AmwellProvider";

const useAmwell = () => useContext(AmwellProviderContext);

export default useAmwell;
